import { LoaderCircle, Terminal } from 'lucide-react'
import { Button } from '../ui/button'
import { useApiDocUrl } from '@/features/docs/api/redirectSwagger'
import { getErrorMessage } from '@/utils/error'
import { useToast } from '@/hooks/useToast'

const ApiDocLink = () => {
  const { toast } = useToast()
  const { mutateAsync, isPending } = useApiDocUrl({
    mutationConfig: {
      onError: (error) => {
        toast({
          variant: 'destructive',
          title: 'Error',
          description: getErrorMessage(error),
        })
      },
    },
  })

  return (
    <Button variant="secondary" size="icon" onClick={() => mutateAsync()} disabled={isPending}>
      {isPending ? <LoaderCircle className="animate-spin" /> : <Terminal />}
    </Button>
  )
}

export { ApiDocLink }
